"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _blobUtil = require("blob-util");
var _lodash = _interopRequireWildcard(require("lodash"));
var _reactWebcam = _interopRequireDefault(require("react-webcam"));
var _styles = require("./styles");
var _excluded = ["onCapture", "children", "facingMode", "videoConstraints", "orientation", "width", "height", "captureMode", "onReady", "onLoadError", "imageSmoothing", "zoom"];
/* eslint-disable react/destructuring-assignment */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};
var AUTO_START = true;
var cameraType = {
  rear: 'environment',
  front: 'user'
};
var cameraScreenWidth = 512;
var minZoom = 0;
var maxZoom = 0.99;
var zoomProps = {
  min: minZoom,
  max: maxZoom,
  step: maxZoom / 5
};
var Camera = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onCapture = _ref.onCapture,
    children = _ref.children,
    _ref$facingMode = _ref.facingMode,
    facingMode = _ref$facingMode === void 0 ? 'rear' : _ref$facingMode,
    _videoConstraints = _ref.videoConstraints,
    _orientation = _ref.orientation,
    width = _ref.width,
    height = _ref.height,
    _ref$captureMode = _ref.captureMode,
    captureMode = _ref$captureMode === void 0 ? 'canvas' : _ref$captureMode,
    onReady = _ref.onReady,
    onLoadError = _ref.onLoadError,
    _ref$imageSmoothing = _ref.imageSmoothing,
    imageSmoothing = _ref$imageSmoothing === void 0 ? false : _ref$imageSmoothing,
    _ref$zoom = _ref.zoom,
    _zoom = _ref$zoom === void 0 ? 0.1 : _ref$zoom,
    rest = _objectWithoutProperties(_ref, _excluded);
  var orientation = _orientation || (width && height && width < height ? 'portrait' : 'landscape') || 'portrait';
  var videoConstraints = _objectSpread({
    height: {
      ideal: orientation === 'portrait' ? 1080 : 1920
    },
    width: {
      ideal: orientation === 'portrait' ? 1920 : 1080
    },
    facingMode: cameraType[facingMode]
  }, _videoConstraints);
  var canvasCamera = (0, _react.useRef)(null);
  var ctxCamera = canvasCamera.current && canvasCamera.current.getContext('2d');
  var webcam = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    cameraActive = _useState2[0],
    setCameraActive = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    track = _useState4[0],
    setTrack = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    setCapabilities = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    canvasIntervals = _useState8[0],
    setCanvasIntervals = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    run = _useState10[0],
    setRun = _useState10[1];
  var _useState11 = (0, _react.useState)(_zoom),
    _useState12 = _slicedToArray(_useState11, 2),
    zoom = _useState12[0],
    setZoom = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    nativeZoomAvailable = _useState14[0],
    setNativeZoomAvailable = _useState14[1];
  var _useState15 = (0, _react.useState)(0.1),
    _useState16 = _slicedToArray(_useState15, 2),
    nativeZoom = _useState16[0],
    setNativeZoom = _useState16[1];
  var _useState17 = (0, _react.useState)({
      step: 1
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    nativeZoomProps = _useState18[0],
    setNativeZoomProps = _useState18[1];
  var zoomAvailable = (0, _react.useMemo)(function () {
    return captureMode === 'canvas' || captureMode === 'camera' && nativeZoomAvailable;
  }, [nativeZoomAvailable, captureMode]);
  var setCanvasSize = function setCanvasSize() {
    var _webcam$current;
    if (webcam !== null && webcam !== void 0 && (_webcam$current = webcam.current) !== null && _webcam$current !== void 0 && _webcam$current.video) {
      var _webcam$current2, _webcam$current3;
      canvasCamera.current.height = webcam === null || webcam === void 0 || (_webcam$current2 = webcam.current) === null || _webcam$current2 === void 0 || (_webcam$current2 = _webcam$current2.video) === null || _webcam$current2 === void 0 ? void 0 : _webcam$current2.videoHeight;
      canvasCamera.current.width = webcam === null || webcam === void 0 || (_webcam$current3 = webcam.current) === null || _webcam$current3 === void 0 || (_webcam$current3 = _webcam$current3.video) === null || _webcam$current3 === void 0 ? void 0 : _webcam$current3.videoWidth;
    }
  };
  var handleCapture = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cb) {
      var imgObj, canvas, blob, dataUrl;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(run && webcam.current && canvasCamera.current && track)) {
              _context.next = 27;
              break;
            }
            imgObj = {};
            if (!(captureMode === 'canvas')) {
              _context.next = 18;
              break;
            }
            _context.next = 5;
            return delay(100);
          case 5:
            canvas = canvasCamera.current;
            _context.next = 8;
            return (0, _blobUtil.canvasToBlob)(canvasCamera.current, 'image/jpeg');
          case 8:
            blob = _context.sent;
            _context.t0 = canvas;
            _context.t1 = blob;
            _context.next = 13;
            return (0, _blobUtil.blobToDataURL)(blob);
          case 13:
            _context.t2 = _context.sent;
            _context.t3 = captureMode;
            imgObj = {
              canvas: _context.t0,
              blob: _context.t1,
              dataUrl: _context.t2,
              captureMode: _context.t3
            };
            _context.next = 25;
            break;
          case 18:
            dataUrl = webcam.current.getScreenshot();
            _context.next = 21;
            return (0, _blobUtil.dataURLToBlob)(dataUrl);
          case 21:
            _context.t4 = _context.sent;
            _context.t5 = dataUrl;
            _context.t6 = captureMode;
            imgObj = {
              blob: _context.t4,
              dataUrl: _context.t5,
              captureMode: _context.t6
            };
          case 25:
            if ((0, _lodash.isFunction)(cb)) cb(imgObj);
            if ((0, _lodash.isFunction)(onCapture)) onCapture(imgObj);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCapture(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var paintToCanvas = function paintToCanvas() {
    var videoHeight = webcam.current.video.videoHeight;
    var videoWidth = webcam.current.video.videoWidth;
    var scale = 1 - zoom;
    var scaleWidth = videoWidth * scale;
    var scaleHeight = videoHeight * scale;
    var scaledX = (videoWidth - scaleWidth) / 2;
    var scaledY = (videoHeight - scaleHeight) / 2;
    var canvasInterval = setInterval(function () {
      if (webcam.current) {
        ctxCamera.drawImage(_lodash["default"].get(webcam, 'current.video'), scaledX, scaledY, scaleWidth, scaleHeight, 0, 0, videoWidth, videoHeight);
      }
    }, 50);
    return [canvasInterval];
  };
  var zoomOut = function zoomOut() {
    if (zoomAvailable && zoom - zoomProps.step * nativeZoomProps.step >= zoomProps.min) setZoom(zoom - zoomProps.step * nativeZoomProps.step);
    if (zoomAvailable && nativeZoom - nativeZoomProps.step >= nativeZoomProps.min) {
      setNativeZoom(nativeZoom - nativeZoomProps.step);
    }
  };
  var zoomIn = function zoomIn() {
    if (zoomAvailable && zoom + zoomProps.step * nativeZoomProps.step <= zoomProps.max) setZoom(zoom + zoomProps.step * nativeZoomProps.step);
    if (zoomAvailable && nativeZoom + nativeZoomProps.step <= nativeZoomProps.max) {
      setNativeZoom(nativeZoom + nativeZoomProps.step);
    }
  };
  (0, _react.useEffect)(function () {
    if (track && nativeZoomAvailable) {
      track.applyConstraints({
        advanced: [{
          zoom: nativeZoom
        }]
      });
    }
  }, [nativeZoom, nativeZoomAvailable, track]);
  var onUserMedia = function onUserMedia() {
    var mediaStream = webcam.current.stream;
    var mediaStreamTrack = mediaStream.getTracks()[0];
    var capabilities = mediaStreamTrack.getCapabilities();
    var settings = mediaStreamTrack.getSettings();
    setCapabilities(capabilities);
    setTrack(mediaStreamTrack);
    webcam.current.video.onloadedmetadata = function () {
      setCanvasSize();
      setCameraActive(true);
      if (captureMode === 'camera') {
        setNativeZoomAvailable(settings.zoom);
        setNativeZoomProps(capabilities.zoom);
        setNativeZoom(capabilities.zoom.min);
      }
    };
    if (onReady && mediaStreamTrack) {
      onReady({
        capabilities: capabilities,
        settings: settings
      });
    }
  };
  var stop = function stop() {
    setRun(false);
  };
  var start = function start() {
    setRun(true);
    setCanvasIntervals(paintToCanvas());
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      capture: handleCapture,
      zoomIn: zoomIn,
      zoomOut: zoomOut,
      startCamera: start,
      stopCamera: stop
    };
  });
  (0, _react.useEffect)(function () {
    if (canvasIntervals) {
      canvasIntervals.forEach(function (interval) {
        clearInterval(interval);
      });
    }
    if (AUTO_START && cameraActive) {
      start();
    }
  }, [cameraActive, zoom]);
  (0, _react.useEffect)(function () {
    if (track) {
      onUserMedia();
    }
  }, [track, captureMode]);
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, _extends({
    orientation: orientation,
    width: width,
    height: height
  }, rest), children, /*#__PURE__*/_react["default"].createElement(_reactWebcam["default"], {
    ref: webcam,
    audio: false,
    videoConstraints: videoConstraints,
    screenshotFormat: "image/jpeg",
    minScreenshotWidth: cameraScreenWidth,
    minScreenshotHeight: cameraScreenWidth,
    onUserMedia: onUserMedia,
    onUserMediaError: onLoadError,
    screenshotQuality: 1,
    width: "100%",
    imageSmoothing: imageSmoothing,
    forceScreenshotSourceSize: true,
    style: {
      opacity: 0,
      position: 'absolute'
    }
  }), /*#__PURE__*/_react["default"].createElement(_styles.Canvas, {
    ref: canvasCamera,
    orientation: orientation,
    width: width,
    height: height
  }));
});

// https://www.npmjs.com/package/react-webcam
Camera.propTypes = {
  children: _propTypes["default"].node,
  facingMode: _propTypes["default"].string,
  captureMode: _propTypes["default"].string,
  onCapture: _propTypes["default"].func,
  onReady: _propTypes["default"].func,
  onLoadError: _propTypes["default"].func,
  zoom: _propTypes["default"].number,
  videoConstraints: _propTypes["default"].object,
  orientation: _propTypes["default"].string,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  imageSmoothing: _propTypes["default"].bool
};
var _default = exports["default"] = Camera;